var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{staticClass:"SubSider"},[_c('NavMenu',{attrs:{"defaultActive":_vm.defaultActive,"navMenus":_vm.navList},on:{"select":function($event){return _vm.$emit('select',$event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }